const soundsData = {
	ding: require('../assets/audio/ding.mp3'),
	login: require('../assets/audio/login.mp3')
}

module.exports = {soundsData};